<template>
    <v-responsive>

        <h1>e커머스피칭페스타 소개</h1>
        
        <section class="mt-4">
            <div>소개페이지 데이터는 <b>[관리자 > e커머스피칭페스타 소개]</b> 페이지에 접속하시면 수정할 수 있습니다.</div>
            <div><b>festa 오브젝트</b>에 담겨져 있고, 그 안에 <b>section + 2~6</b> 네이밍으로 데이터가 들어가 있습니다.</div>
            
            <div class="mt-4"><b>채연씨 요청사항)</b></div>
            <div> * 로고는 한줄에 최대 4개씩만 들어가며, 4개 미만일때 왼쪽 정렬해달라고 요청해주셨습니다.</div>

            <div class="mt-4"><b>수정시 유의사항)</b></div>
            <div> * <b>v-html</b>은 삭제하지 말아주세요. 엔터가 html에서 보여지지 않기때문에, br태그로 변경해주어야 하기 때문입니다.</div>
            
            <div class="mt-4"><b>23.02.28 채연씨 추가 요청) 개최 성과 추가</b></div>
            <div> * 개최 성과 텍스트가 추가되었습니다, <b>festa.section4.txt[0]</b> 데이터 바인딩이 추가되었습니다.</div>

            <example-layout class="overflow-auto mt-8">
                <template v-slot:render>
                    <example-festa />
                </template>
                
                <template v-slot:editor>
                    <prism-editor v-model="example.section_1.code" line-numbers class="rounded"></prism-editor>
                </template>
            </example-layout>
        </section>
    </v-responsive>
</template>

<script>
import api from "@/api";
import prismEditor from '@/components/developer/prism-editor.vue';
import exampleLayout from "@/components/developer/example-layout.vue";

import exampleFesta from '@/components/developer/kea/example-festa.vue';

export default {
    components: {
        prismEditor,
        exampleLayout,
        exampleFesta
    },
    data(){
        return {
            example: {
                section_1: {
                    code: `<template>\n    <div v-if=\"festa\">\n        <section class=\"text-left\">\n            <h2>행사 소개</h2>\n            <b v-html=\"festa.section2.txt[0]?.replace(/\\n/g, '<br/>')\" />\n            <p v-html=\"festa.section2.txt[1]?.replace(/\\n/g, '<br/>')\" />\n        </section>\n\n        <section class=\"text-left\">\n            <h2>행사 개요</h2>\n            <table>\n                <tbody>\n                    <template v-for=\"item, index in festa.section3.table.list\">\n                        <tr :key=\"index\">\n                            <td><p v-html=\"item.title.replace(/\\n/g, '<br />')\" /></td>\n                            <td><p v-html=\"item.input.replace(/\\n/g, '<br />')\" /></td>\n                        </tr>\n                    </template>\n                </tbody>\n            </table>\n        </section>\n\n        <section class=\"text-left d-block\">\n            <h2>개최성과</h2>\n            <p v-html=\"festa.section4.txt[0]\" />\n        </section>\n\n        <section class=\"text-left d-block\">\n            <h2>프로그램</h2>\n            <p v-html=\"festa.section5.txt[0]\" />\n        </section>\n\n        <section class=\"text-left d-block\">\n            <h2>Partners</h2>\n            <p v-html=\"festa.section6.contents.frame2211.txt[0]\" />\n\n            <template v-for=\"logoItems, row in festa.section6.contents.frame2302.logoList\">\n                <v-row :key=\"row\">\n                    <template v-for=\"{ src, url }, col in logoItems\">\n                        <v-col cols=\"3\" :key=\"col\">\n                            <a :href=\"url\">\n                                <v-img :src=\"src\" contain height=\"96\" />\n                            </a>\n                        </v-col>\n                    </template>\n                    <v-spacer />\n                </v-row>\n            </template>\n        </section>\n    </div>\n</template>\n\n<script>\nimport api from \"@/api\";\n\nexport default {\n    data(){\n        return {\n            festa: null\n        }\n    },\n    mounted(){\n        this.init();\n    },\n\n    methods: {\n        async init(){\n            let { festa } = await api.v1.kea.festa.get();\n            this.festa = festa;\n        }\n    }\n}\n<\/script>`
                }
            }
        }
    }
}
</script>